<template>
  <VTable
    :items="payments"
    :fields="fields"
    :checked-rows="checkedItems"
    :loading="loading"
    :on-toggle-row="onToggleRow"
    :on-toggle-all="onToggleAll"
    :on-input-search="onInputSearch"
    :on-edit-item="onEditItem"
    :on-delete-item="onDeleteItem"
    searchPlaceholder="Search for dealer...."
    hideAddButton
    hover
    striped
    border
    small
    fixed
    dark
  >
    <template #footer>
      <VPagination
        :items-count="itemsCount"
        class="user-manager-card__footer-pagination"
      />
    </template>
  </VTable>
</template>
<script>
import {
  createPaymentsMixin,
  paymentsStore,
} from "@/mixins/paymentsMixin";
import { debounce } from "@/utils/debounce";

export default {
  name: "Payments",
  mixins: [createPaymentsMixin()],
  components: {},
  computed:{
    fields() {
      return [
        {
          key: "carTitle",
          label: "Car Title",
          _style: "min-width: 125px",
          _classes: "carTitle"
        },
        {
          key: "ownerName",
          label: "Owner Name",
          _classes: "ownerName"
        },

        {
          key: "bidderName",
          label: "Bidder Name",
          _classes: "bidderName"
        },
        {
          key: "amount",
          label: "amount",
          _classes: "amount"
        },
        {
          key: "intentId",
          label: "Stripe IntentId",
          _classes: "intentId"
        },
      ];
    },
    checkedItems() {
      return this[paymentsStore.getterTypes.GETTER_CHECKED_ROWS];
    },
    itemsCount() {
      return this[paymentsStore.getterTypes.GETTER_PAYMENTS_COUNT];
    },
    payments() {
      let arr = []
      const paymentsRaw = this[paymentsStore.getterTypes.GETTER_PAYMENTS];
      if(paymentsRaw.length > 0){
        for(let i =0; i < paymentsRaw.length; i++){
          arr.push({
            carTitle: paymentsRaw[i].car?.title,
            ownerName: paymentsRaw[i].owner?.username,
            bidderName: paymentsRaw[i].bidder?.username,
            amount: paymentsRaw[i].amount,
            intentId: paymentsRaw[i].intentId
          })
        }
      }
      return arr
    },
  },
  data: () => {
    return {
      loading: false,
      lastSearchTerm: null,
      searchFn: () => {}
    };
  },
  methods:{
    onToggleRow({ item }) {
      this[paymentsStore.mutationTypes.SET_CHECKED_ROW](item);
    },
    onToggleAll(items) {
      this[paymentsStore.mutationTypes.SET_CHECKED_ROWS](items);
    },
    onInputSearch(t) {
      this.searchFn(t);
    },
    async loadData() {
      this.loading = true;
      await this[paymentsStore.actionTypes.ACTION_LOAD_PAYMENTS]({
        skip: this.$route.query.skip || 0,
        take: this.$route.query.take || 10,
        search: this.$route.query.search || ''
      })
      this.loading = false
    },
  },
  watch: {
    $route() {
      console.log('Route changed');

      this.loadData()
    }
  },
  async created() {
    this.loadData()
    this.searchFn = debounce.call(
      this,
      async term => {
        const query = {
          ...this.$route.query,
          search: term
        };

        if (!query.search && query.offset) {
          query.offset = 0;
        }

        this.$router
          .push({
            query
          })
          .catch(() => {});
      },
      200
    );
  }
};
</script>

